import { TagColor } from '@equip.health/ui';
import { AssessmentDisplayStatus } from './AssessmentDisplayStatus';

export const StatusBadgeToColorMap: Record<AssessmentDisplayStatus, TagColor> =
  {
    [AssessmentDisplayStatus.COMPLETE]: TagColor.gray,
    [AssessmentDisplayStatus.IN_PROGRESS]: TagColor.periwinkle,
    [AssessmentDisplayStatus.INCOMPLETE]: TagColor.red,
    [AssessmentDisplayStatus.NEW]: TagColor.marigold,
  };
